// Elysium weekly class timetable (kept in step with backend/seed.py WEEKLY_SCHEDULE).
export const DAYS = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];

const ff = (time, coach) => ({ time, name: "Functional Fitness", coach });

export const TIMETABLE = {
  Monday: [ff("06:00", "Andrew Finnegan"), ff("07:00", "Peter Crudge"), ff("17:00", "Andrew Finnegan"), ff("18:00", "Peter Crudge")],
  Tuesday: [ff("06:00", "Peter Crudge"), ff("07:00", "Andrew Finnegan"), ff("17:00", "Peter Crudge"),
    { time: "18:00", name: "Olympic Lifting", coach: "Peter Crudge" }, ff("19:00", "Andrew Finnegan")],
  Wednesday: [ff("06:00", "Andrew Finnegan"), ff("07:00", "Peter Crudge"), ff("17:00", "Andrew Finnegan"), ff("18:00", "Peter Crudge")],
  Thursday: [ff("06:00", "Peter Crudge"), ff("07:00", "Andrew Finnegan"),
    { time: "17:00", name: "Olympic Lifting", coach: "Peter Crudge" }, ff("18:00", "Andrew Finnegan")],
  Friday: [ff("06:00", "Andrew Finnegan"), ff("07:00", "Peter Crudge"), ff("17:00", "Andrew Finnegan"), ff("18:00", "Peter Crudge")],
  Saturday: [{ time: "09:00", name: "Olympic Lifting", coach: "Peter Crudge" },
    { time: "10:00", name: "Super Saturday", coach: "Andrew Finnegan & Peter Crudge" }],
  Sunday: [{ time: "09:00", name: "Engine", coach: "Andrew Finnegan" }],
};

export const slotLabel = (day, s) => `${day} ${s.time} · ${s.name}`;
export const ALL_SLOTS = DAYS.flatMap((d) => TIMETABLE[d].map((s) => slotLabel(d, s)));
